var _path, _path2, _circle, _circle2, _path3, _circle3, _path4, _circle4, _path5, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-mn",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c4272f",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#015197",
    d: "M170.667 0h170.667v512H170.667z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.627,
    cy: 215.251,
    r: 27.996,
    fill: "#f9cf02"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.627,
    cy: 202.526,
    r: 30.541,
    fill: "#c4272f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.919 169.458c0 7.018 5.69 12.707 12.708 12.707s12.707-5.69 12.707-12.707c0-5.084-3.177-5.719-3.177-7.625 0-1.906 1.907-4.448-1.906-7.625 1.906 3.177-1.27 3.813-1.27 6.99 0 3.176 1.27 3.176 1.27 5.718a2.542 2.542 0 0 1-5.083 0c0-2.542 2.542-5.083 2.542-8.895 0-3.813-.636-5.083-2.542-8.26-1.906-3.177-5.083-5.719-2.541-8.26-3.813 1.27-1.907 6.353-1.907 9.53 0 3.177-2.541 5.083-2.541 8.896 0 3.812 1.906 4.447 1.906 6.989a2.542 2.542 0 0 1-5.083 0c0-2.542 1.27-2.542 1.27-5.718 0-3.177-3.176-3.813-1.27-6.99-3.812 3.177-1.906 5.719-1.906 7.625 0 1.906-3.177 2.541-3.177 7.625z",
    fill: "#f9cf02",
    fillRule: "evenodd"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.627,
    cy: 207.616,
    r: 20.36,
    fill: "#f9cf02"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.635 248.337v122.162h25.45V248.337zm86.532 0v122.162h25.45V248.337zm-55.991 20.36v10.18h50.901v-10.18zm0 71.262v10.18h50.901v-10.18zm0-91.622h50.901l-25.45 15.27zm0 106.892h50.901l-25.45 15.27z",
    fill: "#f9cf02"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.627,
    cy: 309.418,
    r: 26.978,
    fill: "#f9cf02",
    stroke: "#c4272f",
    strokeWidth: 3.054
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.627 282.44a13.489 13.489 0 0 1 0 26.978 13.489 13.489 0 1 0 0 26.978",
    fill: "none",
    stroke: "#c4272f",
    strokeWidth: 3.054
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 5.09,
    cy: 295.929,
    cx: 85.627,
    fill: "#c4272f"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 5.09,
    cy: 322.907,
    cx: 85.627,
    fill: "#c4272f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn);
export default __webpack_public_path__ + "static/media/mn.96fe6b077294c5b34eb4eb5b46edf96a.svg";
export { ForwardRef as ReactComponent };